import styled from "styled-components";
import { IconArrowLeft } from "./IconArrowLeft";

export const IconArrowRight = styled(IconArrowLeft)`
  transform: rotate(180deg);
`;
